import { MsalAuthenticationResult } from '@azure/msal-react';
import { Heading } from '@flixbus/honeycomb-react';
import React from 'react';

export const ErrorComponent: React.FC<MsalAuthenticationResult> = ({ error }) => {
  return <Heading size={4}>An Error Occurred: {error ? error.errorCode : 'unknown error'}</Heading>;
};
